@if (title) {
  <span class="quote-card__title">{{ title }}</span>
}
<span class="quote-card__mark" aria-hidden="true">&ldquo;</span>
<p class="quote-card__arabic">{{ arabic }}</p>
<p class="quote-card__translation">{{ translation }}</p>
<span class="quote-card__reference">{{ reference }}</span>
